<template>
  <div class="survey-main">
    <div id="survey-form">
      <h1 class="center-it bold"></h1>
       <span class="center-it"><h2>Survey Summarize</h2></span>
       <div class="chat-container">
          <div class="chat-window" id="chatWindow" ref="chatWindow">
              <span v-html="responseText"></span>
          </div>
          <div class="chat-input-container">
            <button
              type="button"
              class="chat-input-container"
              @click="getResponse"
            >
              Summarize
            </button>
          </div>
      </div><br>
      <span class="center-it">
          <a href="https://www.machinecore.com/" target="_new">
            <img
              class="powered-logo"
              src="../assets/machinecore_logo_small_final@2x.png"
              srcset="
            ../assets/machinecore_logo_small_final@1x.png 1x,
            ../assets/machinecore_logo_small_final@2x.png 2x
          "
            />
          </a><br/><a href="#" @click.prevent="logout">Logout</a> 
        </span>
      <br />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  data() {
    return {
      prompt: "I had a bad experience with buying jeans",
      responseText: "",
    };
  },
  created() {
  },
  methods: {
    getResponse: async function () {
      try {
        const response = await fetch(`http://localhost:8000/summarize`, {
          credentials: "include",
          mode: "cors",
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const reader = response.body.getReader();

        let responseData = '';

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          let chunk = new TextDecoder().decode(value);

          // Replace every newline character with <br />
          chunk = chunk.replace(/\n/g, '<br />');

          console.log(chunk)
          this.responseText += chunk;
          this.scrollToBottom();
        }
        this.responseText += '<br />';
        // Close the reader
        reader.releaseLock();
      } catch (error) {
        console.error("Error fetching response:", error);
        // Handle errors, perhaps setting some error state or notifying the user
      }
    },
    logout: async function () {
      try {
        const response = await fetch(`http://localhost:8000/logout`, {
          credentials: "include",
          mode: "cors",
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
      } catch (error) {
        console.error("Error fetching response:", error);
        // Handle errors, perhaps setting some error state or notifying the user
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const chatWindow = this.$refs.chatWindow;
        chatWindow.scrollTop = chatWindow.scrollHeight;
      });
    }
  },
};
</script>
<style>

body, html {
    height: 100%;
    margin: 0;
    font-family: Arial, sans-serif;
    background: #fafafa;
}
.center-it {
  display: block;
  text-align: center;
}
#survey-form {
  margin: 60px auto 0 auto;
  padding: 20px;
  width: 70%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 5px 15px 0 rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid #cfe1f6;
}
.chat-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 10px;
}

.chat-window {
    flex-grow: 1;
    overflow-y: auto;
    height: 600px;
    border: 1px solid #ccc;
    padding: 10px;
    margin-bottom: 10px;
}

.chat-input-container {
    display: flex;
    justify-content: center;   /* Center the button horizontally */
    align-items: center;       /* Center the button vertically */
    width: 100%;
}

.chat-input-container button {
    width: 24%;
    align-content: center;
    padding: 10px;
    height: 50px;
    background-color: #007BFF;
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box; /* Include padding and border in the element's total width and height */
}

.chat-input-container button:hover {
    background-color: #0056b3;
}

.user-message {
    background-color: #f1f1f1;
    padding: 10px;
    border-radius: 5px;
    margin: 5px 0;
}
</style>
